module.exports = __webpack_public_path__ + "img/ba.34d536ef.svg";